import { useEffect, useState } from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';

import toast from 'react-hot-toast';
import { t } from 'i18next';
import { Helmet } from 'react-helmet';

import styles from './Billing.module.css';
import PlanUi from '../../../components/UI/Common/PlanUi/PlanUi';
import PlanUsageUi from '../../../components/UI/Common/PlanUsageUi/PlanUsageUi';
import JobseekerFeaturesUi from '../../../components/UI/Common/JobseekerFeaturesUi/JobseekerFeaturesUi';
import InvoiceUi from '../../../components/UI/Common/InvoiceUi/InvoiceUi';
import SimpleLink from '../../../components/UI/Buttons/SimpleLink/SimpleLink';
import BubbleButton from '../../../components/UI/Buttons/BubbleButton/BubbleButton';
import CancelConfirmation from '../CancelConfirmation/CancelConfirmation';
import CancelConfirmationForEmployer from '../CancelConfirmationForEmployer/CancelConfirmationForEmployer';
import CancelSubscriptionModal from '../../../components/UI/Popups/CancelSubscriptionModal/CancelSubscriptionModal';
import { setDisableHeader, setInvoices } from '../../../app/features/userSlice';
import { fetchInvoices, resumeSubscription } from '../../../services/paymentService';
import { RecommendProfile } from '../../../assets/images/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchUserByToken } from '../../../app/features/userSlice';
import { getJobsList } from '../../../services/jobService';
import { checkContactRevealPermission } from '../../../services/contactRevealService';
import axios from 'axios';

function Billing({ onSeeAllPlans, handleCancelSubscription, isEmployerSubscription }) {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [invoicesSt, setInvoicesSt] = useState([]);
    const [expandedFAQ, setExpandedFAQ] = useState(null);
    const [cancelSubs, setCancelSubs] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [jobspostedList, setJobspostedList] = useState(0);
    const [jobsLoading, setJobsLoading] = useState(true);
    const [contactRevealsCount, setContactRevealsCount] = useState(0);
    const [contactRevealsLoading, setContactRevealsLoading] = useState(true);
    const dispatch = useDispatch(null)
    const user = useSelector(state => state.user.user);
    const userToken = useSelector(state => state.user.token);
    const invoices = useSelector(state => state.user.invoices);
    const location = useLocation();
    const navigate = useNavigate();
    const [selectedInvoice, setSelectedInvoice] = useState()
    const [invoicesFetching, setInvoicesFetching] = useState(false);

    const [selectedTab, setSelectedTab] = useState(
        location.pathname.includes("/invoice") ? 'billingHistory' :
            location.pathname === '/profile/billing-history' ? 'billingHistory' :
                location.pathname === '/profile/plan-usage' && user.account_type === 'employer' ? 'planUsage' :
                    location.pathname === '/profile/features' && user.account_type === 'jobseeker' ? 'features' :
                        'subscription'
    );
    useEffect(() => {
        if (location?.pathname?.includes("/invoice")) {
            const selectedInvoiceNumber = location.pathname.split("/")[2]
            const selectedInvoice = invoices?.filter((item) => item.number == selectedInvoiceNumber || item.invoiceNumber == selectedInvoiceNumber)
            if (selectedInvoice?.length > 0) setSelectedInvoice(selectedInvoice[0])
            // dispatch(setDisableHeader(true))
            // setSelectedInvoice(invoice); // Set the selected invoice for full view
            // navigate(`/invoice/${location.pathname}`)
        }
    }, [location, invoices?.length])
    const faqData = [
        { question: t('faq.premiumSubscription'), answer: t('faq.charges') },
        { question: t('faq.cancelSubscription'), answer: t('faq.cancelInfo') },
        { question: t('faq.freeTrial'), answer: t('faq.trialInfo') },
        { question: t('faq.upgradePlan'), answer: t('faq.upgradeInfo') },
        { question: t('faq.autoRenewal'), answer: t('faq.autoRenewInfo') }
    ];

    const handleFAQClick = (index) => { setExpandedFAQ(expandedFAQ === index ? null : index); };

    useEffect(() => {
        setInvoicesSt(invoices)
    }, [invoices])

    useEffect(() => {
        const getInvoices = async () => {
            // Skip if already fetching to prevent multiple toasts
            if (invoicesFetching) return;

            try {
                setInvoicesFetching(true);

                // Dismiss any existing toasts
                toast.dismiss();

                toast.promise(fetchInvoices(user.email, 20), {
                    loading: t('general.UI.loading'),
                    success: <b>{t('general.UI.success')}</b>,
                    error: (err) => {
                        return <b>{err.error}</b>;
                    },
                })
                    .then((fetchedInvoices) => {
                        setLoading(false);
                        dispatch(setInvoices({ fetchedInvoices: fetchedInvoices.userInvoices, totalCount: fetchedInvoices.totalCount }))
                    })
                    .catch((err) => {
                        toast.error(t('general.UI.something_went_wrong'));
                        setLoading(false);
                    })
                    .finally(() => {
                        setInvoicesFetching(false);
                    });
            } catch (err) {
                setError(err);
                setLoading(false);
                setInvoicesFetching(false);
            }
        };

        if (user.email && selectedTab === 'billingHistory') {
            getInvoices();
        }
    }, [user.email, selectedTab]);

    let price = user?.subscription_price?.unit_amount / 100;
    let priceName;
    if (user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_MONTH || user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_BASIC_FOR_1_YEAR) {
        priceName = t('employer_plan.Basic')
    } else if (user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_MONTH || user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_SME_FOR_1_YEAR) {
        priceName = t('employer_plan.SME')
    } else if (user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_FREE_FOR_1_MONTH || user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_SUB_PRICE_ID_RECURRING_FREE_FOR_1_YEAR) {
        priceName = t('employer_plan.Free')
    } else if (user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_1_MONTH_RECURRING) {
        priceName = t('plans.1_month_plan.title')
    } else if (user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_2_MONTH_RECURRING) {
        priceName = t('plans.3_month_plan.title')
    } else if (user.activeSubscriptionPriceId == process.env.REACT_APP_STRIPE_VERIFICATION_PRICE_ID_FOR_3_MONTH_RECURRING) {
        priceName = t('plans.6_month_plan.title')
    }
    useEffect(() => {
        if (selectedTab === 'subscription') {
            navigate('/profile/billing');
        } else if (selectedTab === 'billingHistory') {
            if (location.pathname.includes("/invoice")) {
                navigate(location.pathname);
            } else {
                navigate('/profile/billing-history');
            }
        } else if (selectedTab === 'planUsage') {
            if (user.account_type === 'employer') {
                navigate('/profile/plan-usage');
            } else {
                // Redirect jobseekers to subscription tab if they try to access plan usage
                setSelectedTab('subscription');
                navigate('/profile/billing');
            }
        } else if (selectedTab === 'features') {
            if (user.account_type === 'jobseeker') {
                navigate('/profile/features');
            } else {
                // Redirect employers to subscription tab if they try to access features
                setSelectedTab('subscription');
                navigate('/profile/billing');
            }
        }
    }, [selectedTab, user.account_type]);
    const priceAfterDiscount = user?.subscriptionDetail?.discount?.coupon?.percent_off && (user?.subscriptionDetail?.plan?.amount / 100) - (((user?.subscriptionDetail?.plan?.amount / 100) * user?.subscriptionDetail?.discount?.coupon.percent_off) / 100)
    const handleShowCancelModal = () => {
        if (user?.subscriptionStatus === 'active' && user.account_type == 'employer') {
            setShowCancelModal(true);
        } else {
            setCancelSubs(true);
        }
    };

    const handleConfirmCancel = () => {
        setShowCancelModal(false);
        setCancelSubs(true);
    };

    const handleResumeSubscription = () => {
        setLoading(true);
        resumeSubscription(userToken)
            .then((response) => {
                toast.success(t('subscription.resume_success', 'Subscription resumed successfully'));
                dispatch(fetchUserByToken(userToken));
                setLoading(false);
            })
            .catch(error => {
                console.error('Error resuming subscription:', error);
                toast.error(t('subscription.resume_error', 'Error resuming subscription'));
                setLoading(false);
            });
    };
    const features = useSelector(state => state.user.features);

    // Get features from Redux store
    useEffect(() => {
        if (user.account_type === 'employer') {
            const getJobsListData = async () => {
                setJobsLoading(true);
                try {
                    const response = await getJobsList(1, 99999, null, { employer_id: user.id }, user.employer_status || user.jobseeker_status);
                    const activeJobsCount = response?.jobs.filter((e) => e.status == 'active').length;
                    setJobspostedList(activeJobsCount);
                } catch (error) {
                    console.error('Error fetching jobs:', error);
                } finally {
                    setJobsLoading(false);
                }
            }
            getJobsListData();

            // Fetch contact reveals count
            const getContactRevealsCount = async () => {
                setContactRevealsLoading(true);
                try {
                    // Get current date
                    const currentDate = new Date();
                    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

                    // Make API call to get contact reveals count
                    const response = await axios.get(
                        `${process.env.REACT_APP_API_URL}user/contacts/count-reveals/${user.id}`,
                        {
                            headers: {
                                'Authorization': `Bearer ${userToken}`,
                                'Content-Type': 'application/json'
                            },
                            params: {
                                startDate: firstDayOfMonth.toISOString()
                            }
                        }
                    );
                    if (response.data && response.data.success) {
                        setContactRevealsCount(response.data.count);
                    } else {
                        console.error('Error in API response:', response.data);
                        // Set to 0 as a fallback
                        setContactRevealsCount(0);
                    }
                } catch (error) {
                    console.error('Error fetching contact reveals count:', error);
                    // Set to 0 as a fallback on error
                    setContactRevealsCount(0);
                } finally {
                    setContactRevealsLoading(false);
                }
            }
            getContactRevealsCount();
        }
    }, [user.account_type, user.id, userToken])

    // Define planUsageData inside the component body using the state value
    const isPaused = user?.subscriptionDetail?.pause_collection || user?.subscriptionStatus === 'paused';

    const planUsageData = {
        instantJobActivation: isPaused ? false : features?.instantJobActivation === 1,
        monthlyJobs: jobspostedList,
        totalMonthlyJobs: isPaused ? 0 : (features?.monthlyJobsLimit || 0),
        // applicationsPerJob: 0, // Current count would need to be tracked elsewhere
        totalApplicationsPerJob: isPaused ? 0 : (features?.applicationsPerJob || 0),
        jobseekerDatabaseAccess: isPaused ? false : features?.jobseekersDBAccess === 1,
        viewApplicantsProfile: isPaused ? false : features?.viewApplicantProfile === 1,
        contactReveals: contactRevealsCount,
        totalContactReveals: isPaused ? 0 : (features?.contactReveal || 0),
        contactApplicant: isPaused ? false : features?.contactApplicant === 1,
        viewDownloadResume: isPaused ? false : features?.viewDownloadResume === 1
    };
    // Define jobseeker features based on user's subscription
    const hasActiveSubscription = user?.subscriptionStatus === 'active' && !isPaused;

    const jobseekerFeaturesData = {
        verifiedBadge: hasActiveSubscription,
        exclusiveJob: hasActiveSubscription,
        uploadMultipleCVs: hasActiveSubscription,
        increasedVisibility: hasActiveSubscription,
        instantNotification: hasActiveSubscription,
        showHidePhoto: hasActiveSubscription,
        directMessage: hasActiveSubscription,
        profileInsights: hasActiveSubscription
    };

    return (
        <>
            <CancelSubscriptionModal
                show={showCancelModal}
                onClose={() => setShowCancelModal(false)}
                onConfirm={handleConfirmCancel}
            />

            {!cancelSubs ?
                <div className={styles.wrapper}>
                    <Helmet>
                        <title>FindCV - Billing</title>
                    </Helmet>
                    <div className={`${styles.container} ${styles.fcvRow}`}>
                        <p className={styles.title}>{t('billing.title')}</p>
                        <div style={{ width: '410px' }}>
                            <div className={styles.linkContainer}>
                                <SimpleLink
                                    className={`${styles.headerLink} ${selectedTab === 'subscription' ? styles.active : ''}`}
                                    style={{ textDecoration: "none" }}
                                    onClick={() => setSelectedTab('subscription')}
                                >
                                    {t('billing.subscription')}
                                </SimpleLink>
                                <div className={styles.rightBorder} style={{ margin: '10px' }} />
                                {user.account_type === 'employer' && (
                                    <>
                                        <SimpleLink
                                            className={`${styles.headerLink} ${selectedTab === 'planUsage' ? styles.active : ''}`}
                                            style={{ textDecoration: "none" }}
                                            onClick={() => setSelectedTab('planUsage')}
                                        >
                                            {t('billing.planUsage', 'Plan Usage')}
                                        </SimpleLink>
                                        <div className={styles.rightBorder} style={{ margin: '10px' }} />
                                    </>
                                )}
                                {user.account_type === 'jobseeker' && (
                                    <>
                                        <SimpleLink
                                            className={`${styles.headerLink} ${selectedTab === 'features' ? styles.active : ''}`}
                                            style={{ textDecoration: "none" }}
                                            onClick={() => setSelectedTab('features')}
                                        >
                                            {t('billing.features', 'Features')}
                                        </SimpleLink>
                                        <div className={styles.rightBorder} style={{ margin: '10px' }} />
                                    </>
                                )}
                                <SimpleLink
                                    className={`${styles.headerLink} ${selectedTab === 'billingHistory' ? styles.active : ''}`}
                                    style={{ textDecoration: "none" }}
                                    onClick={() => setSelectedTab('billingHistory')}
                                >
                                    {t('billing.billingHistory')}
                                </SimpleLink>
                            </div>
                        </div>
                        <div className={styles.contentWrapper}>
                            {selectedTab === 'subscription' ?
                                <PlanUi
                                    subscriptionId={user.stripeSubscriptionId}
                                    handleCancelSubscription={handleShowCancelModal}
                                    handleResumeSubscription={handleResumeSubscription}
                                    interval_count={user?.subscriptionDetail?.plan?.interval_count || t('planUI.unlimited')}
                                    interval={user?.subscriptionDetail?.plan?.interval || ''}
                                    default_payment_method={user?.subscriptionDetail?.paymentMethodDetail?.type || t('planUI.Default')}
                                    start_date={user?.subscriptionDetail?.start_date || new Date(user.createdAt).toLocaleDateString('en-GB')}
                                    autoRenewalStatus={user?.subscriptionDetail?.cancel_at_period_end ? false : true}
                                    current_period_end={user?.subscriptionDetail?.current_period_end || t('planUI.No_expiry')}
                                    cancel_at_period_end={user?.subscriptionDetail?.cancel_at_period_end}
                                    cancel_at={user?.subscriptionDetail?.cancel_at}
                                    discount={user?.subscriptionDetail?.discount?.coupon?.name}
                                    onSeeAllPlans={onSeeAllPlans}
                                    status={user?.subscriptionDetail?.pause_collection ? 'paused' : user?.subscriptionStatus || 'active'}
                                    price={
                                        user?.subscriptionDetail?.discount?.coupon.percent_off ?
                                            priceAfterDiscount
                                            :
                                            user?.subscriptionDetail?.plan?.amount / 100 || 0}
                                    planName={priceName?.length > 0 ? priceName : '' || t('planUI.FREE')}
                                /> :

                                selectedTab === 'planUsage' ? (
                                    <div className={styles.planContainer}>
                                        <PlanUsageUi
                                            planName={isPaused ? t('planUI.FREE') : (priceName?.length > 0 ? priceName : '' || t('planUI.FREE'))}
                                            instantJobActivation={planUsageData.instantJobActivation}
                                            monthlyJobs={planUsageData.monthlyJobs}
                                            totalMonthlyJobs={planUsageData.totalMonthlyJobs}
                                            // applicationsPerJob={planUsageData.applicationsPerJob}
                                            totalApplicationsPerJob={planUsageData.totalApplicationsPerJob}
                                            jobseekerDatabaseAccess={planUsageData.jobseekerDatabaseAccess}
                                            contactReveals={planUsageData.contactReveals}
                                            totalContactReveals={planUsageData.totalContactReveals}
                                            viewApplicantsProfile={planUsageData.viewApplicantsProfile}
                                            contactApplicant={planUsageData.contactApplicant}
                                            viewDownloadResume={planUsageData.viewDownloadResume}
                                            isJobsLoading={jobsLoading}
                                            isContactRevealsLoading={contactRevealsLoading}
                                            isPaused={isPaused}
                                        />
                                    </div>
                                ) :
                                    selectedTab === 'features' ? (
                                        <div className={styles.planContainer}>
                                            <JobseekerFeaturesUi
                                                planName={isPaused ? t('planUI.FREE') : (priceName?.length > 0 ? priceName : '' || t('planUI.FREE'))}
                                                verifiedBadge={jobseekerFeaturesData.verifiedBadge}
                                                exclusiveJob={jobseekerFeaturesData.exclusiveJob}
                                                uploadMultipleCVs={jobseekerFeaturesData.uploadMultipleCVs}
                                                increasedVisibility={jobseekerFeaturesData.increasedVisibility}
                                                instantNotification={jobseekerFeaturesData.instantNotification}
                                                showHidePhoto={jobseekerFeaturesData.showHidePhoto}
                                                directMessage={jobseekerFeaturesData.directMessage}
                                                profileInsights={jobseekerFeaturesData.profileInsights}
                                                isPaused={isPaused}
                                            />
                                        </div>
                                    ) :
                                        <InvoiceUi invoices={invoicesSt} selectedInvoiceData={selectedInvoice} />
                            }

                            <div className={styles.faqContainer}>
                                <p className={styles.faqHeading}>{t('faq.title')}</p>
                                {faqData.map((faq, index) => (
                                    <div key={index} className={styles.faqItem}>
                                        <div className={styles.faqQuestion} onClick={() => handleFAQClick(index)}>
                                            <p>{faq.question}</p>
                                            <span className={styles.circleIcon}>{expandedFAQ === index ? '-' : '+'}</span>
                                        </div>
                                        {expandedFAQ === index && <p className={styles.faqAnswer}>{faq.answer}</p>}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className={styles.seePlanContentWrapper}>
                            <div className={styles.seeAllPlan}>
                                <img
                                    src={RecommendProfile}
                                    alt={t('billing.seeAllPlans')}
                                    className={styles.recommendProfile}
                                />
                                <p className={styles.seePlansMsg}>{t('billing.seeUpgradeMessage')}</p>
                                <BubbleButton
                                    to={!isEmployerSubscription && "/subscriptions"}

                                    headerButton
                                    onClick={onSeeAllPlans}
                                    className={'seePlansBtn'}
                                >{t('billing.seeAllPlans')}</BubbleButton>
                            </div>
                            <div className={styles.faqContainerEmpty}></div>
                        </div>
                    </div >
                </div >
                :
                user.account_type == 'jobseeker' ?
                    <CancelConfirmation cancelSubscription={handleCancelSubscription} />
                    :
                    user.discountApplied ?
                        <CancelConfirmation cancelSubscription={handleCancelSubscription} />
                        :
                        <CancelConfirmationForEmployer cancelSubscription={handleCancelSubscription} />
            }
        </>
    );
}

export default Billing;
